"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = __importDefault(require("styled-components"));
var getIcon_1 = __importDefault(require("../utils/getIcon"));
var StyledInfoIcon = styled_components_1.default(getIcon_1.default('Information'))(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 1.25rem;\n  min-width: 1.25rem;\n  height: 1.25rem;\n  min-height: 1.25rem;\n  vertical-align: middle;\n  background-color: ", ";\n  border: 5px solid ", ";\n  border-radius: 100%;\n  cursor: pointer;\n  margin: 0 0.25rem;\n"], ["\n  width: 1.25rem;\n  min-width: 1.25rem;\n  height: 1.25rem;\n  min-height: 1.25rem;\n  vertical-align: middle;\n  background-color: ", ";\n  border: 5px solid ", ";\n  border-radius: 100%;\n  cursor: pointer;\n  margin: 0 0.25rem;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.info.color.normal;
}, function (_a) {
    var theme = _a.theme;
    return theme.info.color.normal;
});
exports.default = StyledInfoIcon;
var templateObject_1;
//# sourceMappingURL=StyledInfoIcon.js.map